module.exports = __webpack_public_path__ + "images/CarouselImg1_ac4e3d8.png";